import React from "react";
import styles from "../styles/ContactPage.module.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactFormSection from "./ContactForm";
import FAQSection from "../components/FAQSection";

const ContactPage = () => {
  return (
    <div className={styles.contactPage}>
      <Navbar />

      {/* Hero Section */}
      <section className={`${styles.heroSection} section-container`}>
        <div className={styles.heroTag}>Contact Us</div>
        <h1 className={styles.heroTitle}>
          Let's Build Something Amazing Together
        </h1>
        <p className={styles.heroDescription}>
          Ready to transform your ideas into reality? Get in touch with our team
          and let's discuss how we can help your business grow.
        </p>
      </section>

      <ContactFormSection />

    
    <FAQSection />

    <Footer/>
    </div>
  );
};

export default ContactPage;
